var exports = {
  "VH": "ForwardMessagePreview.module__preview___VVVwZn",
  "Qs": "ForwardMessagePreview.module__content___VVVwZn",
  "iU": "ForwardMessagePreview.module__message___VVVwZn",
  "Mg": "ForwardMessagePreview.module__messageWithAttachments___VVVwZn",
  "oh": "ForwardMessagePreview.module__edited___VVVwZn",
  "kp": "ForwardMessagePreview.module__attachmentRow___VVVwZn",
  "$r": "ForwardMessagePreview.module__attachmentIcon___VVVwZn",
  "eI": "ForwardMessagePreview.module__attachmentSummary___VVVwZn",
  "rs": "ForwardMessagePreview.module__attachmentSummaryWithText___VVVwZn",
  "vH": "ForwardMessagePreview.module__thumbnailStack___VVVwZn",
  "xn": "ForwardMessagePreview.module__thumbnail___VVVwZn",
  "q_": "ForwardMessagePreview.module__thumbnailImage___VVVwZn",
  "SK": "ForwardMessagePreview.module__thumbnailPlaceholder___VVVwZn",
  "XX": "ForwardMessagePreview.module__thumbnailPlaceholderIcon___VVVwZn",
  "Uy": "ForwardMessagePreview.module__thumbnailVideo___VVVwZn",
  "tk": "ForwardMessagePreview.module__thumbnailSensitive___VVVwZn",
  "$3": "ForwardMessagePreview.module__thumbnailWithOverflow___VVVwZn",
  "uZ": "ForwardMessagePreview.module__playIcon___VVVwZn",
  "mB": "ForwardMessagePreview.module__overflowCount___VVVwZn",
};

module.exports = exports;
